import React from 'react';
import { Row, Icon } from 'antd';

import './style.less'

export default (props) => (
  <Row type="flex" justify="center" align="middle" className="loading_page">
    <Icon type="loading" spin className="icon" />
  </Row>
)